<div class="h-4 pb-8" *transloco="let t; prefix: 'userInteraction.dialog'">
  <button
    mat-icon-button
    [matTooltip]="t('open')"
    [matTooltipPosition]="'above'"
    (click)="openDialog()"
  >
    <mat-icon>eject</mat-icon>
  </button>
</div>
